<div class="temp-react-host">
  <iframe
    class="temp-react-host__iframe"
    src="/assets/temp-react/index.html"
    title="Temporary React app"
    sandbox="allow-downloads allow-forms allow-modals allow-same-origin allow-scripts"
  ></iframe>
</div>
